<template>
  <div
    v-cloak
    class="search-bar-wrapper"
    :class="{ 'search-bar-wrapper-active': isOpen }"
  >
    <div class="search-bar" :class="{ 'search-bar-active': isOpen }">
      <input
        type="text"
        placeholder="Suche"
        v-model="query"
        v-on:keyup="autoComplete"
        class="form-control"
        @focus.prevent="toggleResult()"
        v-on:keyup.enter="navigateToResultPage"
      />
      <img @click.prevent="open()" src="/img/icons/search.svg" />

      <!-- <input type="text" placeholder="Suche"> -->
    </div>
    <div
      class="panel-footer"
      v-if="(results.length || noResults) && showResults"
    >
      <p class="list-group-item" v-if="noResults">Keine Ergebnisse</p>
      <a
        :href="'/idee/' + result.id"
        class="list-group-item"
        v-for="result in results"
        :key="result.id"
      >
        <span class="result-title">{{ result.title }}</span>

        <span class="result-category">{{ result.category.title }}</span>

        <img class="result-goto" src="/img/icons/arrow-right.svg" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      query: "",
      results: [],
      isOpen: false,
      showResults: false,
      noResults: false,
    };
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside);
      }
    },
    // showResults(isOpen) {
    //   if (isOpen) {

    //     document.addEventListener("click", this.closeIfClickedOutsideResults);
    //   }
    // },
  },
  methods: {
    navigateToResultPage() {
        document.location = "/suche?q="+ this.query;
    },

    toggleResult() {
      this.showResults = true;
      setTimeout(() => {
        document.addEventListener("click", this.closeIfClickedOutsideResults);
      }, 500);
    },
    open() {
      if (window.innerWidth < 591) {
        this.isOpen = !this.isOpen;
        this.showResults = !this.showResults;
        if (this.isOpen) {
          document.querySelector("#logo").style.display = "none";
        } else {
          document.querySelector("#logo").style.display = "block";
        }
      }
    },

    autoComplete() {
      this.results = [];
      this.noResults = false;
      if (this.query.length > 2) {
        axios
          .get("/search", { params: { query: this.query } })
          .then((response) => {
            console.log("THIS", response);
            this.showResults = true;
            document.addEventListener(
              "click",
              this.closeIfClickedOutsideResults
            );
            this.results = response.data;
            if (this.results.length < 1) {
              this.noResults = true;
            }
          }).catch((error) => {
            console.log(error);
          });
      }
    },
    closeIfClickedOutside(event) {
      if (!event.target.closest(".search-bar")) {
        this.isOpen = false;
        document.querySelector("#logo").style.display = "block";
        document.removeEventListener("click", this.closeIfClickedOutside);
      }
    },
    closeIfClickedOutsideResults(event) {
      if (!event.target.closest(".panel-footer")) {
        this.showResults = false;
        document.removeEventListener(
          "click",
          this.closeIfClickedOutsideResults
        );
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style>
</style>
